import { useCallback, useState } from "react";
import { getHubsAnalytics } from "../../../api";
import { HubsAnalyticsResponse } from "../types";

interface FetchArgs {
    folderIds: string[];
    startDate: Date;
    endDate: Date;
}

interface UseHubAnalytics {
    data: HubsAnalyticsResponse | null;
    loading: boolean;
    error: string | null;
    fetch: (args: FetchArgs) => Promise<void>;
    reset: () => void;
}

export const useHubAnalytics = (): UseHubAnalytics => {
    const [data, setData] = useState<HubsAnalyticsResponse | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetch = useCallback(async ({ folderIds, startDate, endDate }: FetchArgs) => {
        const token = localStorage.getItem("token");
        if (!token) {
            setError("missing-token");
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const res = await getHubsAnalytics({ token, folderIds, startDate, endDate });
            setData(res);
        } catch (e: any) {
            setError(e?.message || "unknown-error");
        } finally {
            setLoading(false);
        }
    }, []);

    const reset = useCallback(() => {
        setData(null);
        setError(null);
    }, []);

    return { data, loading, error, fetch, reset };
};
